import {
  AuthorizationNotifier,
  AuthorizationRequest,
  RedirectRequestHandler,
  AuthorizationServiceConfiguration,
  FetchRequestor,
  BaseTokenRequestHandler,
  BasicQueryStringUtils,
  TokenRequest,
  GRANT_TYPE_AUTHORIZATION_CODE,
  GRANT_TYPE_REFRESH_TOKEN,
  TokenResponse,
} from '@openid/appauth';
// import {isLocalhost, oauthDevelopmentStatePrefix} from './utils';
import Config from '@/config';

const httpClient = new FetchRequestor();

class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input) {
    return super.parse(input, false /* never use hash */);
  }
}

class AuthFlow {
  constructor(locationLike = window.location) {
    this.notifier = new AuthorizationNotifier();
    this.authorizationHandler = new RedirectRequestHandler(undefined, new NoHashQueryStringUtils(), locationLike);
    this.tokenHandler = new BaseTokenRequestHandler(httpClient);
    this.configuration = undefined;
    this.codeVerifier = undefined;
    this.code = undefined;
    this.isAuthorizationComplete = false;

    this.authorizationHandler.setAuthorizationNotifier(this.notifier);
    this.notifier.setAuthorizationListener((request, response, error) => {
      console.log('Authorization request complete ', request, response, error);

      if (response) {
        this.isAuthorizationComplete = true;
        this.code = response.code;

        if (request.internal && request.internal.code_verifier) {
          this.codeVerifier = request.internal.code_verifier;
        }
      }
    });
  }

  checkForAuthorizationResponse() {
    return this.authorizationHandler.completeAuthorizationRequestIfPossible();
  }

  fetchServiceConfiguration() {
    return AuthorizationServiceConfiguration.fetchFromIssuer(Config.VUE_APP_MOBILE_OAUTH_CONFIG_URL, httpClient).then(response => {
      this.configuration = response;
      return response;
    });
  }

  authorize() {
    if (!this.configuration) {
      console.log('Unknown service configuration');
      return;
    }

    const request = new AuthorizationRequest({
      client_id: Config.VUE_APP_MOBILE_OAUTH_CLIENT_ID,
      redirect_uri: Config.VUE_APP_MOBILE_OAUTH_REDIRECT_URL,
      scope: Config.VUE_APP_MOBILE_OAUTH_SCOPES,
      response_type: AuthorizationRequest.RESPONSE_TYPE_CODE,
      audience: 'http://localhost:8080/',
      state: undefined,
    });

    // if (isLocalhost()) {
    //   request.state = `${oauthDevelopmentStatePrefix}-${btoa(window.location.origin)}-${request.state}`;
    // }

    console.log('Making authorization request ', this.configuration, request);

    this.authorizationHandler.performAuthorizationRequest(this.configuration, request);
  }

  getAccessToken() {
    if (!this.configuration) {
      console.log('Unknown service configuration');
      return Promise.resolve();
    }

    const extras = {
      client_secret: Config.client_secret,
    };

    if (this.codeVerifier) {
      extras.code_verifier = this.codeVerifier;
    }

    // use the code to make the token request.
    let request = new TokenRequest({
      client_id: Config.VUE_APP_MOBILE_OAUTH_CLIENT_ID,
      redirect_uri: Config.VUE_APP_MOBILE_OAUTH_REDIRECT_URL,
      grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
      code: this.code,
      refresh_token: undefined,
      extras: extras,
    });

    return this.tokenHandler.performTokenRequest(this.configuration, request).then(response => {
      console.log(`Refresh Token is ${response.refreshToken}`);
      this.setAccessToken(response);
      return response;
    });
  }

  setAccessToken(accessToken) {
    localStorage.setItem('refreshToken', accessToken.refreshToken);
    localStorage.setItem('accessToken', JSON.stringify(accessToken));
    //добавить сеттинг хидера TokenOauth2 для всех запросов
  }

  removeAccessToken() {
    this.isAuthorizationComplete = false;
    this.code = null;
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('alreadyVisited');
    //удалить из хидера TokenOauth2 для всех запросов
  }

  refreshAccessToken() {
    if (!this.configuration) {
      console.log('Unknown service configuration');
      return Promise.resolve();
    }

    const extras = {
      client_secret: Config.client_secret,
    };

    if (this.codeVerifier) {
      extras.code_verifier = this.codeVerifier;
    }

    // TODO: check if exist
    const refreshToken = localStorage.getItem('refreshToken');

    let request = new TokenRequest({
      client_id: Config.VUE_APP_MOBILE_OAUTH_CLIENT_ID,
      redirect_uri: Config.VUE_APP_MOBILE_OAUTH_REDIRECT_URL,
      grant_type: GRANT_TYPE_REFRESH_TOKEN,
      code: undefined,
      refresh_token: refreshToken,
      extras: extras,
    });

    return this.tokenHandler.performTokenRequest(this.configuration, request).then(response => {
      console.log(`Refresh Token is ${response.refreshToken}`);
      localStorage.setItem('refreshToken', response.refreshToken);
      localStorage.setItem('accessToken', JSON.stringify(response));
      return response;
    });
  }

  formatAccessString(accessTokenString) {
    // метод для преобразования формата параметров из localStorage к виду, необходимому для работы в TokenResponse
    const accessTokenJson = JSON.parse(accessTokenString);
    if (accessTokenJson.hasOwnProperty.call('accessToken')) {
      accessTokenJson.access_token = accessTokenJson.accessToken;
    }
    if (accessTokenJson.hasOwnProperty.call('expiresIn')) {
      accessTokenJson.expires_in = accessTokenJson.expiresIn;
    }
    if (accessTokenJson.hasOwnProperty.call('idToken')) {
      accessTokenJson.id_token = accessTokenJson.idToken;
    }
    if (accessTokenJson.hasOwnProperty.call('issuedAt')) {
      accessTokenJson.issued_at = accessTokenJson.issuedAt;
    }
    if (accessTokenJson.hasOwnProperty.call('refreshToken')) {
      accessTokenJson.refresh_token = accessTokenJson.refreshToken;
    }
    if (accessTokenJson.hasOwnProperty.call('tokenType')) {
      accessTokenJson.token_type = accessTokenJson.tokenType;
    }
    return accessTokenJson;
  }

  isAccessTokenPresent() {
    const accessTokenString = localStorage.getItem('accessToken');

    if (!accessTokenString) {
      return false;
    } else {
      // TODO: catch parsing error
      const accessToken = new TokenResponse(this.formatAccessString(accessTokenString));
      return !!accessToken;
    }
  }

  isAccessTokenValid() {
    const accessTokenString = localStorage.getItem('accessToken');

    if (!accessTokenString) {
      return false;
    } else {
      // TODO: catch parsing error
      const accessToken = new TokenResponse(this.formatAccessString(accessTokenString));
      return accessToken.isValid();
    }
  }
}

export default new AuthFlow();
